<template>
  <div class="xh-esg-page">
    <el-row class="xh-esg-header">
      <el-col :span="24">
        <div class="xh-esg-header-banner"></div>
      </el-col>
    </el-row>
    <el-row class="xh-esg-content">
      <el-row :gutter="20">
        <el-col class="xh-esg-left" :span="getLeftSpan">
          <el-row class="xh-esg-left-block">
            <Left :menus="leftMenus" @select="leftSelect"></Left>
          </el-row>
          <el-row class="xh-esg-left-block">
            <Attach></Attach>
          </el-row>
        </el-col>
        <el-col class="xh-esg-right" :span="getRightSpan">
          <List :classifyCode="classifyCode"></List>
        </el-col>
      </el-row>
      <!-- <el-row>ddd </el-row> -->
    </el-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Left from "@/components/layout/Left";
import List from "./components/List";
import Attach from "./components/Attach";
import utilKeepComponent from "@/mixins/utilKeepComponent";
export default {
  mixins: [utilKeepComponent],
  willKeepAliveComponents: ['dynamicDetail'],
  data() {
    return {
      leftMenus: [],
      classifyCode: "XCBG_XHXY_ESG_ZhengFu",
    };
  },
  components: {
    Left,
    List,
    Attach,
  },
  computed: {
    getLeftSpan() {
      let leftMenus = this.leftMenus;
      if (leftMenus && leftMenus.length) {
        return 6;
      } else {
        return 0;
      }
    },
    getRightSpan() {
      let leftMenus = this.leftMenus;
      if (leftMenus && leftMenus.length) {
        return 18;
      } else {
        return 24;
      }
    },
  },
  mounted() {
    this.getLeftMenuList().then((data) => {
      this.leftMenus = data;
    });
  },
  methods: {
    ...mapActions("dynamicInfo/index", {
      getLeftMenuList: "GET_LEFT_MENU_LIST",
    }),
    leftSelect(index) {
      let currentMenu = this.leftMenus[index];
      this.classifyCode = currentMenu.code;
    },
  },
};
</script>
<style lang="scss" scoped>
.xh-esg-page {
  .xh-esg-header {
    .xh-esg-header-banner {
      height: 220px;
      background: url("../../assets/white_theme/esg-banner-dynamic.png")
        no-repeat;
      background-position: center;
      background-size: cover;
    }
  }
  .xh-esg-content {
    max-width: 1100px;
    margin: auto;
    margin-top: 30px;
  }
  .xh-esg-left {
    .xh-esg-left-block {
      padding: 0px 25px;
      background-color: var(--comp_06);
      margin-bottom: 15px;
    }
  }
  .xh-esg-right {
  }
}
</style>
